import type { RegisteredPost } from "@/lib/post";

export default {
  __type: "post",
  published: true,
  author: "Zach Garrett",
  title: "Affordance Predicates",
  tags: ["formal methods"],
  summary: "Representing cones as classifiers over trajectory space",
  posts: {},
} satisfies RegisteredPost;

